import MinecraftText from '../MinecraftText';
import { LegacyMinecraftText } from '../LegacyMinecraftText';
import { ShopChangelogMcText } from '../../types/shopChangelog';

interface MinecraftPageNameProps {
  text: ShopChangelogMcText | undefined | null;
  className?: string;
  clusterId?: string;
  /** Render visibly as struck-through (for "renamed from" displays). */
  strikethrough?: boolean;
}

/**
 * Renders a page name from the shop-changelog payload. The wire format is
 * permissive: page names sometimes arrive as raw `§`-coloured strings, and
 * sometimes as parsed Minecraft text components. We dispatch on type.
 */
export function MinecraftPageName({ text, className, clusterId = 'common', strikethrough }: MinecraftPageNameProps) {
  if (text == null || text === '') {
    return <span className={className}><span className="text-glass-500 italic">unnamed</span></span>;
  }

  const wrapperClass = strikethrough ? `${className ?? ''} line-through opacity-70` : className;

  if (typeof text === 'string') {
    return <LegacyMinecraftText text={text} className={wrapperClass} />;
  }

  return (
    <span className={wrapperClass}>
      <MinecraftText component={text as any} clusterId={clusterId} />
    </span>
  );
}
